import React, { useContext, useState } from 'react'
import { ContextoGlobal, ContextoGlobalInterface } from '../GlobalStates/ContextoGlobal'
import BackEndAPI from '../Services/BackEndAPI'
import { Button, Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close'
import InputText from '../DevComponents/InputText'
import SelectMultiplo from '../DevComponents/SelectMultiplo'
import ExibirJSONDev from '../DevComponents/ExibirJSONDev'
import { clsUtils } from 'zlib-utils'
import ClsValidacao from '../Utils/ClsValidacao'
import Chart from './Chart'
import { dashAgendamentoInputInterface, relDashAgendamentoInterface } from '../ImportBackend/Interfaces/DashBoardsInterfaces'
import ClsFormatacao from '../Utils/ClsFormatacao'
import { DateTime } from 'luxon'
import Condicional from '../Layout/Condicional'

export default function DashAgendamentos() {

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface

  const abortController: AbortController = new AbortController()

  const navigate = useNavigate()

  const clsApi = new BackEndAPI()

  const ResetPesquisa: dashAgendamentoInputInterface = {
    rsUsuarios: [],
    rsUnidadesOrganizacionais: [],
    anoMesInicio: DateTime.now().toFormat('MM/yyyy'),
    anoMesTermino: DateTime.now().toFormat('MM/yyyy'),
    rsClinicas: []
  }

  const [rsRelAgendamento, setRsRelAgendamento] = useState<relDashAgendamentoInterface>({
    faturamento: {} as any,
    comparecimento: {} as any,
    ticketMedio: {} as any,
    pagamento: {} as any,
  })

  const [rsPesquisa, setRsPesquisa] = useState<dashAgendamentoInputInterface>(ResetPesquisa)

  const [erros, setErros] = useState<Record<string, string>>({})

  const btFechar = () => {
    navigate('/')
  }

  const validarDados = (): boolean => {

    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    if (rsPesquisa.anoMesInicio.length > 0 && rsPesquisa.anoMesTermino.length > 0) {

      if (rsPesquisa.anoMesInicio.length !== 7) {
        erros.inicio = 'Data inicial inválida'
        retorno = false
      }

      if (rsPesquisa.anoMesTermino.length !== 7) {
        erros.termino = 'Data final inválida'
        retorno = false
      }

      if (retorno) {

        const [mesInicio, anoInicio] = rsPesquisa.anoMesInicio.split('/');
        const [mesTermino, anoTermino] = rsPesquisa.anoMesTermino.split('/');

        const rsValidarData = { inicio: `${anoInicio}-${mesInicio}-01`, termino: `${anoTermino}-${mesTermino}-01` }

        let clsValidacao = new ClsValidacao()

        retorno = clsValidacao.eData('inicio', rsValidarData, erros, retorno, true)
        retorno = clsValidacao.eData('termino', rsValidarData, erros, retorno, true)

        if (retorno && rsValidarData.inicio > rsValidarData.termino) {
          erros.termino = 'Data final não pode ser menor que a data inicial'
          retorno = false
        }

      }

    }

    setErros(erros)

    return retorno

  }

  const btPesquisar = () => {

    if (validarDados()) {

      const [mesInicio, anoInicio] = rsPesquisa.anoMesInicio.split('/');
      const [mesTermino, anoTermino] = rsPesquisa.anoMesTermino.split('/');

      const query: string = `
        dashAgendamentos (pesquisa: ${clsUtils.ConverterEmGql({
        anoMesInicio: `${anoInicio}${mesInicio}`,
        anoMesTermino: `${anoTermino}${mesTermino}`,
        rsClinicas: rsPesquisa.rsClinicas.map((v: any) => v.idClinica),
        rsUsuarios: rsPesquisa.rsUsuarios.map((v: any) => v.idUsuario),
        rsUnidadesOrganizacionais: rsPesquisa.rsUnidadesOrganizacionais.map((v: any) => v.idUnidadeOrganizacional)
      })})
      `

      clsApi.query<relDashAgendamentoInterface>(query, 'dashAgendamentos', 'Gerando DashBoards...', contexto, abortController).then((rs) => {

        // console.log(rs)
        setRsRelAgendamento(rs)

      })

      return () => {

        abortController.abort()

      }

    }

  }

  const exibirPorcentagemDoTotal = function (this: Highcharts.Point): string {

    let retorno: string = 'ok'

    const valor: number = this.y || 0
    const total: number = this.series.yAxis.series[this.series.yAxis.series.length - 1].data[this.index].y || 0

    if (total !== 0) {
      retorno = '<b>'.concat((valor / total * 100).toFixed(2), '%', '</b>')
    }

    return retorno

  }

  const clsFormatos: ClsFormatacao = new ClsFormatacao()

  const formatarComoFinanceiro = function (this: Highcharts.PointLabelObject): string {

    return clsFormatos.currency(this.y || 0)

  }

  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                DashBoard de Agendamentos
                <Typography variant="body2" gutterBottom>

                </Typography>
              </Typography>

              <IconButton onClick={() => btFechar()}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Grid item xs={12} >

              <SelectMultiplo
                fieldsRetornoObjeto={['idClinica', 'descricao']}
                dados={rsPesquisa}
                field='rsClinicas'
                fieldIdSelect='idClinica'
                fieldSelect='descricao'
                label='Clínicas'
                setState={setRsPesquisa}
                pesquisaInicial={{
                  mensagem: 'Pesquisando Clínicas',
                  tipo: 'Query',
                  pesquisa: 'getClinicas {idClinica, descricao}',
                  objRetorno: 'getClinicas'
                }
                }
              />

            </Grid>

            <Grid item xs={12} md={3}>

              <InputText
                dados={rsPesquisa}
                field='anoMesInicio'
                label='Início'
                mask='00/0000'
                setState={setRsPesquisa}
                erros={erros}
              />

            </Grid>

            <Grid item xs={12} md={3} sx={{ pl: { md: 1 } }}>

              <InputText
                dados={rsPesquisa}
                field='anoMesTermino'
                label='Término'
                mask='00/0000'
                setState={setRsPesquisa}
                erros={erros}
              />

            </Grid>

            <Grid item xs={12} md={3} sx={{ pl: { md: 1 } }}>

              <SelectMultiplo
                fieldsRetornoObjeto={['idUnidadeOrganizacional', 'descricao']}
                dados={rsPesquisa}
                field='rsUnidadesOrganizacionais'
                fieldIdSelect='idUnidadeOrganizacional'
                fieldSelect='descricao'
                label='Unidade Organizacional'
                setState={setRsPesquisa}
                pesquisaInicial={{
                  mensagem: 'Pesquisando Unidades Organizacionais',
                  tipo: 'Query',
                  pesquisa: 'getUnidadesOrganizacionais {idUnidadeOrganizacional, descricao}',
                  objRetorno: 'getUnidadesOrganizacionais'
                }
                }
              />

            </Grid>

            <Grid item xs={12} md={3} sx={{ pl: { md: 1 } }}>

              <SelectMultiplo
                fieldsRetornoObjeto={['idUsuario', 'nome']}
                dados={rsPesquisa}
                field='rsUsuarios'
                fieldIdSelect='idUsuario'
                fieldSelect='nome'
                label='Usuários'
                setState={setRsPesquisa}
                pesquisaInicial={{
                  mensagem: 'Pesquisando Usuários',
                  tipo: 'Query',
                  pesquisa: 'getUsuarios {idUsuario, nome}',
                  objRetorno: 'getUsuarios'
                }
                }
              />

            </Grid>

            <Grid item xs={12} textAlign='right' sx={{ mt: 3 }}>
              <Button variant='contained' onClick={() => { btPesquisar() }}>Pesquisar</Button>
            </Grid>

            <Condicional condicao={rsRelAgendamento.faturamento && rsRelAgendamento.faturamento.series && rsRelAgendamento.faturamento.series.length > 0}>

              <Grid item xs={12} sx={{ mt: 3 }}>
                <Chart
                  tipo='column'
                  titulo='Faturamento'
                  propriedades={rsRelAgendamento.faturamento}
                  subtitulo='Faturamento'
                  tituloY='Valores (R$)'
                  fnFormatarToolTip={exibirPorcentagemDoTotal}
                  fnFormatter={formatarComoFinanceiro}
                />
              </Grid>

              <Grid item xs={12} sx={{ mt: 3 }}>
                <Chart
                  tipo='column'
                  titulo='Ticket Médio'
                  propriedades={rsRelAgendamento.ticketMedio}
                  subtitulo='Ticket Médio'
                  tituloY='Valores (R$)'
                  fnFormatarToolTip={exibirPorcentagemDoTotal}
                  fnFormatter={formatarComoFinanceiro}
                />
              </Grid>

              <Grid item xs={12} sx={{ mt: 3 }}>
                <Chart
                  tipo='column'
                  titulo='Pagamentos'
                  propriedades={rsRelAgendamento.pagamento}
                  subtitulo='Quantidade'
                  tituloY='Quantidades'
                  fnFormatarToolTip={exibirPorcentagemDoTotal}
                />
              </Grid>

              <Grid item xs={12} sx={{ mt: 3 }}>
                <Chart
                  tipo='column'
                  titulo='Comparecimentos'
                  propriedades={rsRelAgendamento.comparecimento}
                  subtitulo='Quantidade'
                  tituloY='Quantidades'
                  fnFormatarToolTip={exibirPorcentagemDoTotal}
                />
              </Grid>

            </Condicional>

          </Grid>

        </Paper>

      </Container >

      <ExibirJSONDev oque={['rsPesquisa', rsPesquisa, 'rsRelAgendamento', rsRelAgendamento]} />

    </>
  )

}